const COLLECTION_PATH = 'collections'
const COLLECTION_LAT_QUERY_PARAM = 'lat'
const COLLECTION_LNG_QUERY_PARAM = 'lng'

export type BuildCollectionUrlProps = {
  baseUrl: string
  affiliateSlug: string
  lat?: string
  lng?: string
}

/**
 * Builds the public collection URL and appends saved collection coordinates
 * only when both coordinates are valid numeric strings. Collections without a saved
 * location keep the existing bare URL behavior.
 */
export const buildCollectionUrl = ({
  baseUrl,
  affiliateSlug,
  lat,
  lng,
}: BuildCollectionUrlProps): string => {
  const collectionUrl = new URL(
    `${baseUrl.replace(/\/$/, '')}/${COLLECTION_PATH}/${affiliateSlug}`,
  )

  if (
    lat !== undefined &&
    lng !== undefined &&
    Number.isFinite(Number(lat)) &&
    Number.isFinite(Number(lng))
  ) {
    collectionUrl.searchParams.set(COLLECTION_LAT_QUERY_PARAM, lat)
    collectionUrl.searchParams.set(COLLECTION_LNG_QUERY_PARAM, lng)
  }

  return collectionUrl.toString()
}
